import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Menu } from "antd";
import "./HeaderBottomMenu.scss";

function HeaderCA() {
  const [current, setCurrent] = useState("");
  const allMenus = useParams();
  const allMenuList = Object.values(allMenus)?.toString()?.split("/");

  const handleClick = () => {
    setCurrent(window.location.pathname);
  };

  useEffect(() => {
    if (["home"].includes(allMenuList[0])) {
      setCurrent("/home");
    } else if (["rewards"].includes(allMenuList[0])) {
      setCurrent("/rewards");
    } else {
      setCurrent("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allMenuList]);

  return (
    <div className="headerBottomRow">
      <Menu
        onClick={handleClick}
        defaultSelectedKeys={["/home"]}
        selectedKeys={[current]}
        defaultOpenKeys={["sub1"]}
        mode="horizontal"
      >
        <Menu.Item key="/home">
          <Link to="/home">Home</Link>
        </Menu.Item>
        <Menu.Item key="/rewards">
          <Link to="/rewards">Rewards</Link>
        </Menu.Item>
      </Menu>
    </div>
  );
}

export default HeaderCA;
